import React, { Component } from 'react';
import { Rate, Button, Spin } from 'antd';
import { inject, observer } from 'mobx-react';
import { getJson } from "@/method";
import moment from 'moment';
import './index.scss';

const area_obj = {
    'ctrip': { name: '携程', bg: '#4C9BF2' },
    'feizhu': { name: '飞猪', bg: '#F6C50E' },
    'meituan': { name: '美团<br/>点评', bg: '#ffc301' },
    'yilong': { name: '同城<br/>艺龙', bg: '#24BC81' },
    'qunar': { name: '去哪儿', bg: '#10A8BC' },
}


@inject('store')
@observer
class index extends Component {

    componentDidMount() {
        const id = this.props.match.params.id;
        const name = this.props.match.params.name;
        this.props.store.criticism.getCriticism(id, name);
    }

    highlight = (word, key = '早餐环境') => {
        let text = word.replace(eval("/(" + key + ")+/gm"), `<span style="color: #4C9BF2">${key}</span>`);
        return <div className='content' dangerouslySetInnerHTML={{ __html: text }}></div>
    }

    getRateScore = (score) => {
        return (score / 10).toFixed(1)
    }

    getTime = (x) => {
        let time = '';
        switch (x.platform) {
            case 'ctrip':
                time = x.createTime.slice(10, 20);
                break;
            case 'qunar':
                time = x.createTime.slice(20, -18).replace(/\D/gm, '-');
                break;
            case 'yilong':
                time = x.createTime;
                break;
            case 'meituan':
                time = x.createTime.slice(33, -19)
                break;
            default:
                break;
        }
        return time;
    }

    render() {
        const { criticismData: data, loading } = this.props.store.criticism;
        return (
            <Spin spinning={loading} tip="加载中。。。">
                <div className='criticism'>
                    <div className='top'>
                        <div className='title'>共检索到包含<span className='c_b'>“{this.props.match.params.id || ""}”</span>的差评 <span className='c_b'>{data.length}</span> 条</div>
                        <Button type="primary" className='returnBtn' onClick={() => { this.props.history.go(-1) }}>返回</Button>
                    </div>
                    <div className='comments'>
                        {(data || []).map((x, i) => {
                            return (
                                <div className='each_list' key={x.id}>
                                    <div className='left'>
                                        <div style={{ background: `${getJson([x.platform, 'bg'], area_obj, "rgb(211, 208, 208)")}` }} className='area' dangerouslySetInnerHTML={{ __html: getJson([x.platform, 'name'], area_obj, "其他") }}></div>
                                        <div className='left_text'>
                                            <div className='score'>{this.getRateScore(x.score)}分<Rate disabled className='star' allowHalf defaultValue={this.getRateScore(x.score)} /></div>
                                            <div className='time'>{x.add_time ? moment(x.add_time).format('YYYY-MM-DD') : ""}</div>
                                        </div>
                                    </div>
                                    {this.highlight(x.content, this.props.match.params.id)}
                                </div>
                            )
                        })}
                    </div>
                </div>
            </Spin>
        )
    }
}

export default index 


// WEBPACK FOOTER //
// ./src/components/table/guestRating/channels/criticism.js